import { DeleteContentOfFolderResponse } from './deletecontentoffolderresponse';
import { Component, Inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ApiRequestService} from '../../../shared/api-request-service';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../../toastmessage/toastmessage.service';
import { HttpError } from '../../../shared/httperror';
import { DeleteContentOfFolderRequest } from './deletecontentoffolderequest';
import { FilemanagerComponent } from '../filemanagerpopup.component';
import { Observable } from 'rxjs';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'pw-deletefilepopup',
  templateUrl: './deletefilepopup.component.html',
  styleUrls: ['./deletefilepopup.component.scss']
})
export class DeletefilepopupComponent {


    deleteContentOfFolderUrl = '/admin/deletefoldercontent';

    fileBaseUrl = '';

    selectedAlign: 'start' | 'center' | 'end';


    isExtraSmall: Observable<BreakpointState>;

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';

    constructor(
        private _toastMessageService: ToastmessageService,
        private _apiRequestService: ApiRequestService,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string,
        private _matdialog:MatDialog,
        @Inject(MAT_DIALOG_DATA) public downloadUri: string,
        private readonly breakpointObserver: BreakpointObserver
    ) {
        this.fileBaseUrl = _fileManagerUrl;

        this.selectedAlign = 'end';

        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);
    }

      //TODO confirm popup!!!
      deleteFile() {
        const deleteFileRequest: DeleteContentOfFolderRequest = {
            downloadUri: this.downloadUri
        };

        this._apiRequestService
            .sendRequest<DeleteContentOfFolderRequest, DeleteContentOfFolderResponse>(
                this.fileBaseUrl,
                true,
                deleteFileRequest,
                true,
                this.deleteContentOfFolderUrl
            )
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(
                            TOAST_STATE.error,
                            'Sikertelen törlés' + httpError.errorMessage,
                            MAT_ICON.error
                        );
                        this.dismissError();
                    });
                })
            )
            .subscribe((response) => {
                this._toastMessageService.displayToastMessage(TOAST_STATE.success, response.message!, MAT_ICON.success);
                this.dismissError();
                this.closeDialog();
                this.openFileManagerPopup();
            });
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }
    closeDialog() {
        this._matdialog.closeAll();
    }

    openFileManagerPopup() {
        const popupDialog = this._matdialog.open(FilemanagerComponent, {
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size: any) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }

}
